import {CampaignStep} from 'common/src/modules/campaignWorkflow/campaignWorkflow.enums';
import routingService from 'common/src/modules/routing/routing.service';
import {CLRoute} from 'common/src/modules/routing/routing.types';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {CLStore} from 'common/src/redux/store';
import _find from 'lodash/find';
import {z} from 'zod';
import {CampaignAnalyticsToolName} from '../campaignAnalyticsAgent.enums';
import {FCCampaign} from 'common/src/modules/campaigns/campaigns.types';

const inputSchema = z.object({
  dashboardId: z.number().nullable().describe('The ID of the dashboard'),
  dashboardName: z.string().nullable().describe('The Name of the dashboard'),
});

function openCampaignDashboardTool(store: CLStore) {
  async function execute({
    input: {dashboardId: requestedDashboardId, dashboardName: requestedDashboardName},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    if (!requestedDashboardId && !requestedDashboardName)
      return toolResult('Dashboard was not requested');

    const state = store.getState();
    const {
      campaignPage: {
        insightsTab: {dashboards},
        campaignTree: {campaign, versionNumber},
      },
    } = state;

    const campaignId = (campaign as FCCampaign).id;

    const dashboard = _find(
      dashboards,
      ({name, id}) => id === requestedDashboardId || name === requestedDashboardName,
    );

    if (!dashboard) return toolError('Dashboard was not found');

    const queryParams = {
      ...Object.fromEntries(new URLSearchParams(document.location.search).entries()),
    };

    routingService.redirectTo({
      url: window.location.pathname as CLRoute,
      pathParams: {campaignId: campaignId, versionNumber: String(versionNumber)},
      queryParams: {
        ...queryParams,
        mode: 'dashboard',
        dashboardId: dashboard.id,
        steps: CampaignStep.Insights,
      },
    });

    return toolResult('Success');
  }

  return tool({
    name: CampaignAnalyticsToolName.OpenDashboard,
    displayName: 'Opening dashboard',
    description: 'open dashboard',
    execute,
    inputSchema,
  });
}

export default openCampaignDashboardTool;
